var map = {
	"./facebook.svg": "2k7W",
	"./instagram.svg": "Hw19",
	"./linkedin.svg": "4LLR",
	"./logo-gemfinance.svg": "ZYZs",
	"./logo-latitude.svg": "bZtK",
	"./twitter.svg": "ellT",
	"./youtube.svg": "5ZO+"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/NyG";